<template>
  <transition name="moo-guest-fade">
    <div
      v-if="show"
      class="moo-guest-backdrop"
      @click.self="$emit('dismiss')"
    >
      <div class="moo-guest-card" role="dialog" aria-modal="true">
        <button
          type="button"
          class="moo-guest-close"
          aria-label="Close"
          @click="$emit('dismiss')"
        >
          <span class="material-icons-round">close</span>
        </button>

        <div class="moo-guest-icon">
          <span class="material-icons-round">card_giftcard</span>
        </div>

        <h2 class="moo-guest-title">{{ $t('rewards.guestPromptTitle') }}</h2>
        <p class="moo-guest-subtitle">{{ $t('rewards.guestPromptBody') }}</p>

        <button
          type="button"
          class="moo-guest-cta moo-guest-cta--primary"
          @click="$emit('signin')"
        >
          {{ $t('rewards.guestPromptCta') }}
        </button>
        <button
          type="button"
          class="moo-guest-cta moo-guest-cta--secondary"
          @click="$emit('dismiss')"
        >
          {{ $t('rewards.guestPromptDismiss') }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
// MTH075: the guest log-in prompt, lifted out of MyReward.vue so the cart can
// show the identical card. Originally MTH052 — the same prompt Advocado shows
// to guests (SF223). The host page decides what "sign in" and "dismiss" mean;
// this component only renders and emits, so MyReward can still navigate back
// while MyCart stays put.
export default {
  name: "GuestRewardPrompt",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["signin", "dismiss"],
};
</script>

<style scoped>
/* Colours track the host page's merchant theme: both MyReward and MyCart set
   --color on their root, and custom properties inherit down the DOM tree even
   though the backdrop is position:fixed. */
.moo-guest-backdrop {
  --gp: var(--color);
  --gp-18: color-mix(in srgb, var(--color) 18%, #ffffff);
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(25, 28, 30, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.moo-guest-card {
  position: relative;
  width: 100%;
  max-width: 22rem;
  background-color: #ffffff;
  border-radius: 1.75rem;
  box-shadow: 0 20px 40px rgba(25, 28, 30, 0.18);
  padding: 2.25rem 1.5rem 1.5rem;
  text-align: center;
}
.moo-guest-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 2;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 9999px;
  background-color: rgba(255, 255, 255, 0.85);
  color: var(--gp);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(25, 28, 30, 0.18);
}
.moo-guest-close .material-icons-round {
  font-size: 1.125rem;
}
.moo-guest-icon {
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 9999px;
  background: var(--gp-18);
  color: var(--gp);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}
.moo-guest-icon .material-icons-round {
  font-size: 1.75rem;
}
/* font-family: inherit — material-dashboard forces Roboto Slab on headings. */
.moo-guest-title {
  font-family: inherit;
  font-weight: 800;
  font-size: 1.5rem;
  letter-spacing: -0.02em;
  color: var(--gp);
  margin: 0 0 0.25rem;
}
.moo-guest-subtitle {
  color: #6b6868;
  font-size: 0.875rem;
  margin: 0 0 1.25rem;
}
.moo-guest-cta {
  width: 100%;
  border-radius: 9999px;
  padding: 0.875rem 1rem;
  font-family: inherit;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
  border: none;
}
.moo-guest-cta + .moo-guest-cta {
  margin-top: 0.5rem;
}
.moo-guest-cta--primary {
  background-color: var(--gp);
  color: #ffffff;
}
.moo-guest-cta--primary:hover {
  opacity: 0.9;
}
.moo-guest-cta--primary:active {
  transform: scale(0.97);
}
.moo-guest-cta--secondary {
  background-color: transparent;
  color: var(--gp);
  text-decoration: underline;
  text-underline-offset: 2px;
}
.moo-guest-fade-enter-active,
.moo-guest-fade-leave-active {
  transition: opacity 0.2s ease;
}
.moo-guest-fade-enter-active .moo-guest-card,
.moo-guest-fade-leave-active .moo-guest-card {
  transition: transform 0.2s ease;
}
.moo-guest-fade-enter-from,
.moo-guest-fade-leave-to {
  opacity: 0;
}
.moo-guest-fade-enter-from .moo-guest-card,
.moo-guest-fade-leave-to .moo-guest-card {
  transform: scale(0.95);
}
</style>
